import { getDepartment } from './departments-service'
import _ from 'lodash'
import { getStyleOptions } from 'shared-js/menu-services/department-styles-service'
import { getItemStyles as inheritedStyles } from 'shared-js/menu-inner-overrides'
import { getCategory } from 'shared-js/menu-services/categories-service'

export function getAllItems (menuBlob) {
  return _.get(menuBlob, 'departments', [])
    .map(department => department.items.map(it => ({ ...it, departmentId: department.id })))
    .reduce((acc, it) => [...acc, ...it], [])
}

export function getDepartmentItems (departmentId, menuBlob) {
  return _.get(getDepartment(departmentId, menuBlob), 'items', [])
}

export function getCategoryItems (categoryId, departmentId, menuBlob) {
  return getDepartmentItems(departmentId, menuBlob).filter(it => it.category === categoryId)
}

export function getItem (itemId, departmentId, menuBlob) {
  return getDepartmentItems(departmentId, menuBlob).find(it => it.id === itemId)
}

export function getVisibleItemStyleOptions (styleId, itemId, categoryId, departmentId, menuBlob) {
  const disabledOptions = _.get(getItemStyles(itemId, categoryId, departmentId, menuBlob), 'disabled', [])

  return getStyleOptions(departmentId, styleId, menuBlob)
    .filter(option => !disabledOptions.find(next => next.styleId === styleId && next.optionId === option.id))
}

function getItemStyles (itemId, categoryId, departmentId, menuBlob) {
  const item = getItem(itemId, departmentId, menuBlob)
  return _.has(item, 'styles') ? item.styles : inheritedStyles(getCategory(categoryId, departmentId, menuBlob), getDepartment(departmentId, menuBlob))
}
